import { useEffect, useRef } from 'react';
import { ContactForm } from './ContactForm';
import { useAnimatedClose } from '../hooks/useAnimatedClose';

export function ContactPanel({ open, onClose }: { open: boolean; onClose: () => void }) {
  const closeRef = useRef<HTMLButtonElement>(null);
  const { closing, requestClose } = useAnimatedClose(onClose);
  useEffect(() => { if (open) closeRef.current?.focus(); }, [open]);
  if (!open) return null;
  return <div className={`modal-backdrop ${closing ? 'is-closing' : ''}`} role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) requestClose(); }}>
    <section className="event-panel contact-panel" role="dialog" aria-modal="true" aria-labelledby="contact-title">
      <button ref={closeRef} className="icon-button" onClick={() => requestClose()} aria-label="Close contact form">×</button>
      <p className="eyebrow">Need an invitation?</p>
      <h2 id="contact-title">Send up a flare.</h2>
      <p className="contact-intro">Tell us who you are. Party details stay private until you receive a personal invitation link.</p>
      <ContactForm />
    </section>
  </div>;
}
